const ACTION = 'FILTER_ITEM_REMOVE';

const actionCreator = () => ({ type: ACTION });

actionCreator.ACTION = ACTION;

export default actionCreator;


// WEBPACK FOOTER //
// ./src/MerchantItems/ActionCreator/clearFilterMenuAction.js